import { Auth0Provider } from "@auth0/nextjs-auth0/client"
import { useRouter } from 'next/router'
import React from "react"
import Layout from "../components/Layout"
import * as gtag from '../lib/gtag'

import { playfair, poppins } from '../scss/fonts'

import "swiper/css/bundle"
// swiper core styles
import "swiper/css"

// modules styles
import "swiper/css/navigation"
import "swiper/css/pagination"

import "../scss/style.default.scss"

const App = ({ Component, pageProps }) => {
  const router = useRouter()

  React.useEffect(() => {
    const handleRouteChange = (url) => {
      gtag.pageview(url)
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  // If you've used `withAuth`, pageProps.user can pre-populate the hook
  // If you haven't used `withAuth`, pageProps.user is undefined so the hook fetches the user from the API routes
  const { user } = pageProps;
  return (
    <main className={`${poppins.variable} ${playfair.variable}`}>
      <Auth0Provider user={user}>
        <Layout {...pageProps}>
          <Component {...pageProps} />
        </Layout>
      </Auth0Provider>
    </main>
  )
}

// This default export is required in a new `pages/_app.js` file.
export default App
